import { Outlet } from 'react-router-dom';
import { SuperAdminLayoutContext } from './SuperAdminLayoutContext';

export function SuperAdminLayout() {
  return (
    <SuperAdminLayoutContext.Provider value={true}>
      <Outlet />
    </SuperAdminLayoutContext.Provider>
  );
}

export default SuperAdminLayout;